import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;
export class SimplePasswordElement extends AbstractBlock {
  constructor() {
    super('simple_password_element_v2', t.to('簡易パスワード', 'simple_password'));
    this.setNameForCode('div');
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementShape(block);
    ColorSettings.setObjectColor(block);

    ShapeSettings.setTitleField(block, this.title);
    const passField = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(`${t.to('パスワード', 'password')}:`)
      .appendField(passField, 'passField');
    ShapeSettings.addAttributeInput(block);
  }

  hash(password: string): string {
    const digest = new TextEncoder().encode(password);
    const byteArray = new Uint8Array(digest);
    // console.log('s', [...byteArray]);
    const hashed = byteArray
      .map((v: any) => {
        return v.toString();
      })
      .join('');
    return hashed;
  }

  generateStaticHTMLCode(block): string {
    const pass = CodeSetting.getFieldValue(block, 'passField');
    // console.log('hash befor pass ', pass);
    const correctPassword = this.hash(pass);
    // console.log('hash after pass ', correctPassword);

    return `<script>
		function hash(password){
      let digest = new TextEncoder().encode(password)
      const byteArray = new Uint8Array(digest);
      return byteArray.map(v => v.toString()).join('')
    }

    function simplePasswordDialog(){
      const result = prompt("パスワードを入力してください")
      if( hash(result) === "${correctPassword}"){
        return true;
      }else if(result === null){
        document.write('パスワード入力がキャンセルされました。');
        return;
      }else{
        // 再帰
        simplePasswordDialog();
      }
    }
    window.addEventListener("load", ()=>{
      simplePasswordDialog();
		})

    // document.addEventListener("DOMContentLoaded", ()=>{
    //   simplePasswordDialog();
		// })
		</script>`;
  }

  codeGenerateCore(block: BlockType): string {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
